import * as React from 'react';
import * as classNames from 'classnames';
import { Modal } from '../../popup';
import { IInsurance } from '../../../../../common/interfaces/insurance';
import { PortalSearchBarField } from '..';

// Styles
const s = require('./InsuranceJobsList.css');
const searchIcon = require('../../../assets/search-icon.svg');

// Props
interface IInsuranceJobsListProps {
    onModalClose: () => void;
    onSearch: (field: string, value: any, e: React.ChangeEvent<HTMLInputElement>) => void;
    onInsurerClick: (insurer: IInsurance) => (e: React.MouseEvent<HTMLButtonElement>) => void;
    showInsuranceJobsModal: boolean;
    selectedInsurer: IInsurance | null;
    insuranceJobs: IInsurance[];
    searchQuery: string;
}

// Component
export const InsuranceJobsList: React.StatelessComponent<IInsuranceJobsListProps> = props => {
    return (
        <Modal
            title="Insurance companies"
            show={props.showInsuranceJobsModal}
            onClose={props.onModalClose}
            closeLabel="Close and cancel"
        >
            <div className={s.search}>
                <PortalSearchBarField
                    autoFocus={true}
                    className={s.searchField}
                    value={props.searchQuery}
                    label="Search insurance companies"
                    field="search"
                    lightness={0}
                    icon={searchIcon}
                    onChange={props.onSearch}
                />
            </div>

            <ul
                className={classNames(s.list, {
                    [s.twoColumns]: props.insuranceJobs.length === 2,
                    [s.oneColumn]: props.insuranceJobs.length <= 1
                })}
            >
                {props.insuranceJobs.map(insurer => (
                    <li
                        key={insurer.id + '-' + insurer.insuranceCode}
                        className={classNames({
                            [s.active]: props.selectedInsurer !== null && props.selectedInsurer.id === insurer.id
                        })}
                    >
                        <button onClick={props.onInsurerClick(insurer)} className={s.insurer}>
                            <span>#{insurer.id}</span>
                            <strong>{insurer.insuranceCode}</strong>
                        </button>
                    </li>
                ))}
            </ul>
        </Modal>
    );
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/layout/InsuranceJobsList/InsuranceJobsList.tsx